import { Paper, Tab, Tabs } from "@mui/material";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";

export const TABS = { ORDERS: 0, BASKETS: 1, MANAGERS: 4 };

// External suppliers only get the orders tab.
const TradeDelayTabs = ({ tab, onChange, isSupplier }) => (
  <Paper
    elevation={0}
    sx={{ borderRadius: 0, border: "1px solid rgba(0,0,0,0.08)", borderTop: "none", borderBottom: "none", mb: 0 }}
  >
    <Tabs
      value={tab}
      onChange={(_, v) => onChange(v)}
      sx={{
        px: 2,
        "& .MuiTab-root": { textTransform: "none", fontWeight: 600, fontSize: "0.9rem", minHeight: 44 },
        "& .Mui-selected": { color: "#0054A5" },
        "& .MuiTabs-indicator": { bgcolor: "#0054A5", height: 3 },
      }}
    >
      <Tab value={TABS.ORDERS} icon={<PauseCircleOutlineIcon fontSize="small" />} iconPosition="start" label="הזמנות בהשהייה" />
      {!isSupplier && (
        <Tab value={TABS.BASKETS} icon={<ShoppingBasketIcon fontSize="small" />} iconPosition="start" label="הגדרת סלים" />
      )}
      {!isSupplier && (
        <Tab
          value={TABS.MANAGERS}
          icon={<SupervisorAccountIcon fontSize="small" />}
          iconPosition="start"
          label="מנהלים וסוכנים"
        />
      )}
    </Tabs>
  </Paper>
);

export default TradeDelayTabs;
